/**
 * theme.js — Willi Mirrors Shopify Theme
 * Vanilla JS implementation of all storefront interactivity.
 * No ES modules, no imports — plain browser script.
 */

(function () {
  'use strict';

  /* =========================================================
   * 1. ATTRIBUTION
   * ========================================================= */
  var CLICK_PARAMS = ['gclid','gbraid','wbraid','gclsrc','utm_source','utm_medium','utm_campaign','utm_term','utm_content','fbclid'];
  var WILLI_ATTR_COOKIE = 'willi_attr';
  var MAX_AGE = 60 * 60 * 24 * 90; // 90 days

  function readCookieVal(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readClickParams() {
    var raw = readCookieVal(WILLI_ATTR_COOKIE);
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function captureClickParams() {
    var params = new URLSearchParams(location.search);
    var existing = readClickParams();
    var updated = false;
    CLICK_PARAMS.forEach(function (key) {
      if (params.has(key)) {
        existing[key] = params.get(key);
        updated = true;
      }
    });
    if (updated) {
      document.cookie = WILLI_ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(existing))
        + '; max-age=' + MAX_AGE + '; path=/; SameSite=Lax';
    }
  }

  function decorateCheckoutUrl(url) {
    if (!url) return url;
    var attrs = readClickParams();
    if (!Object.keys(attrs).length) return url;
    try {
      var u = new URL(url, location.origin);
      Object.keys(attrs).forEach(function (key) {
        if (!u.searchParams.has(key)) {
          u.searchParams.set(key, attrs[key]);
        }
      });
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  /* =========================================================
   * 2. FORMAT MONEY
   * ========================================================= */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* =========================================================
   * 3. ANNOUNCEMENT BAR
   * ========================================================= */
  function initAnnouncementBar() {
    var el = document.getElementById('announcement-text');
    if (!el) return;
    var messages = [
      'Free US Shipping Over $79',
      '90-Day Free Returns · No Restocking Fees',
      'Questions? WhatsApp us: +1 (314) 297-8704'
    ];
    var idx = 0;
    el.textContent = messages[0];
    el.style.transition = 'opacity 300ms ease';
    el.style.opacity = '1';

    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        el.textContent = messages[idx];
        el.style.opacity = '1';
      }, 300);
    }, 4500);
  }

  /* =========================================================
   * 4. DRAWERS
   * ========================================================= */
  var activeDrawer = null;

  function openDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    var overlay = document.getElementById('drawer-overlay');
    if (!drawer) return;

    // Close any existing drawer first
    if (activeDrawer && activeDrawer !== drawer) {
      closeDrawerEl(activeDrawer);
    }

    activeDrawer = drawer;
    drawer.classList.remove('translate-x-full', '-translate-x-full');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    if (overlay) {
      overlay.classList.remove('opacity-0', 'pointer-events-none');
      overlay.classList.add('opacity-100', 'pointer-events-auto');
    }
  }

  function closeDrawerEl(drawer) {
    var overlay = document.getElementById('drawer-overlay');
    if (!drawer) return;

    // Determine direction — mobile menu is left drawer
    if (drawer.id === 'mobile-menu-drawer') {
      drawer.classList.add('-translate-x-full');
    } else {
      drawer.classList.add('translate-x-full');
    }
    drawer.setAttribute('aria-hidden', 'true');

    if (overlay) {
      overlay.classList.add('opacity-0', 'pointer-events-none');
      overlay.classList.remove('opacity-100', 'pointer-events-auto');
    }
    document.body.classList.remove('overflow-hidden');

    if (activeDrawer === drawer) activeDrawer = null;
  }

  function closeActiveDrawer() {
    if (activeDrawer) closeDrawerEl(activeDrawer);
  }

  function initDrawers() {
    // Trigger buttons
    var cartBtn = document.getElementById('header-cart-btn');
    var searchBtn = document.getElementById('header-search-btn');
    var hamburgerBtn = document.getElementById('header-hamburger-btn');

    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        openDrawer('cart-drawer');
        refreshCartDrawer();
      });
    }
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        openDrawer('search-drawer');
        var input = document.getElementById('search-input');
        if (input) setTimeout(function () { input.focus(); }, 100);
      });
    }
    if (hamburgerBtn) {
      hamburgerBtn.addEventListener('click', function () {
        openDrawer('mobile-menu-drawer');
      });
    }

    // Close buttons
    ['cart-drawer-close', 'search-drawer-close', 'mobile-menu-close'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', closeActiveDrawer);
    });

    // Overlay click
    var overlay = document.getElementById('drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeActiveDrawer);

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeActiveDrawer();
    });
  }

  /* =========================================================
   * 5. CART API
   * ========================================================= */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function (r) { return r.json(); });
  }

  function updateCartLine(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function removeCartLine(id) {
    return updateCartLine(id, 0);
  }

  /* =========================================================
   * 6. CART BADGE
   * ========================================================= */
  function updateCartBadge(count) {
    // Always show the number — hiding it left "Bag ()" rendered in the header.
    var badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = count;
  }

  /* =========================================================
   * 7. CART DRAWER RENDER
   * ========================================================= */
  function freeShippingProgressBar(subtotalCents) {
    // Mirrors Hydrogen's FreeShippingProgress (CartSummary.tsx)
    var threshold = 7900; // $79
    if (!subtotalCents) return '';
    var unlocked = subtotalCents >= threshold;
    var pct = Math.min(100, (subtotalCents / threshold) * 100);
    var remaining = ((threshold - subtotalCents) / 100).toFixed(2);
    return [
      '<div class="mb-4">',
        '<p class="font-sans text-xs ' + (unlocked ? 'text-[#00a233]' : 'text-ink/70') + '">',
          unlocked
            ? '✓ You’ve unlocked free standard shipping'
            : 'You’re $' + remaining + ' away from free standard shipping',
        '</p>',
        '<div class="h-1 rounded-full bg-mist mt-2 overflow-hidden">',
          '<div class="h-full rounded-full transition-all duration-500 ' + (unlocked ? 'bg-[#00a233]' : 'bg-clay') + '" style="width:' + pct + '%"></div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function renderCartDrawer(cart) {
    var content = document.getElementById('cart-drawer-content');
    var summary = document.getElementById('cart-drawer-summary');
    if (!content || !summary) return;

    updateCartBadge(cart.item_count);

    if (!cart.item_count) {
      // Mirrors Hydrogen's CartEmpty (CartMain.tsx)
      content.innerHTML = [
        '<div class="text-center pt-16 px-4">',
          '<p class="font-serif italic text-2xl text-ink/70">Your bag is empty</p>',
          '<p class="font-sans text-sm text-ink/50 mt-3 leading-relaxed">Looks like you haven’t added anything yet — let’s find the piece your space is missing.</p>',
          '<a href="/collections/all" class="inline-block bg-ink text-paper font-sans text-[11px] uppercase tracking-[0.2em] px-9 py-4 rounded-full hover:bg-clay transition-colors duration-300 mt-8">Continue Shopping →</a>',
        '</div>'
      ].join('');
      summary.innerHTML = '';
      return;
    }

    // Line items mirror Hydrogen's CartLineItem (aside layout)
    var itemsHtml = '<ul aria-labelledby="cart-lines">';
    cart.items.forEach(function (item) {
      var lineTotal = formatMoney(item.final_line_price);
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?.*)?$/, '_200x$1$2') : '';
      var optionsHtml = '';
      (item.options_with_values || []).forEach(function (opt) {
        if (opt.value !== 'Default Title') {
          optionsHtml += '<li class="font-sans text-[10px] text-ink/40 uppercase tracking-[0.1em]">' + escHtml(opt.name) + ': ' + escHtml(opt.value) + '</li>';
        }
      });
      itemsHtml += [
        '<li class="py-5 border-b border-ink/10">',
          '<div class="flex gap-4">',
            (imgSrc
              ? '<div class="shrink-0 w-20 aspect-[4/5] rounded-xl overflow-hidden bg-mist"><img src="' + imgSrc + '" alt="' + escHtml(item.title) + '" class="w-full h-full object-cover" loading="lazy" width="100" height="125"></div>'
              : ''),
            '<div class="flex-1 min-w-0">',
              '<a href="' + item.url + '">',
                '<p class="font-sans text-xs uppercase tracking-[0.1em] text-ink leading-relaxed line-clamp-2">' + escHtml(item.product_title) + '</p>',
              '</a>',
              '<div class="font-sans text-xs text-ink/60 mt-1"><div aria-label="Price" class="product-price" role="group">' + lineTotal + '</div></div>',
              '<ul class="mt-1 space-y-0.5">' + optionsHtml + '</ul>',
              '<div class="flex items-center gap-3 mt-3">',
                '<div class="flex items-center border border-ink/20 rounded-full">',
                  '<button aria-label="Decrease quantity" class="cart-line-minus px-3 py-1.5 font-sans text-sm text-ink hover:bg-mist rounded-l-full transition-colors cursor-pointer disabled:opacity-30" data-line-id="' + item.key + '"' + (item.quantity <= 1 ? ' data-remove="1"' : '') + '>−</button>',
                  '<span class="w-6 text-center font-sans text-xs">' + item.quantity + '</span>',
                  '<button aria-label="Increase quantity" class="cart-line-plus px-3 py-1.5 font-sans text-sm text-ink hover:bg-mist rounded-r-full transition-colors cursor-pointer" data-line-id="' + item.key + '">+</button>',
                '</div>',
                '<button class="cart-line-remove font-sans text-[10px] uppercase tracking-[0.15em] text-ink/40 hover:text-ink underline underline-offset-2 transition-colors cursor-pointer" data-line-id="' + item.key + '">Remove</button>',
              '</div>',
            '</div>',
          '</div>',
        '</li>'
      ].join('');
    });
    itemsHtml += '</ul>';
    content.innerHTML = itemsHtml;

    // Summary mirrors Hydrogen's CartSummary (aside layout): free-shipping
    // progress + Subtotal + disclaimer + "View Cart →" (no checkout button
    // in the drawer — it lives on the /cart page, per Hydrogen).
    summary.innerHTML = [
      freeShippingProgressBar(cart.total_price),
      '<dl role="group" class="flex items-center justify-between font-sans text-sm text-ink">',
        '<dt class="uppercase tracking-[0.15em] text-xs">Subtotal</dt>',
        '<dd class="font-semibold">' + formatMoney(cart.total_price) + '</dd>',
      '</dl>',
      '<p class="font-sans text-[10px] text-ink/40 mt-1">Shipping, taxes &amp; discount codes calculated at checkout</p>',
      '<a href="/cart" class="group block w-full text-center bg-ink text-paper font-sans text-[11px] uppercase tracking-[0.2em] px-8 py-4 rounded-full hover:bg-clay active:scale-[0.98] transition-all duration-300 mt-4 mb-2">View Cart <span class="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span></a>'
    ].join('');

    // Hide "You may also like" cards for products already in the cart
    filterDrawerRecommendations(cart);
  }

  function filterDrawerRecommendations(cart) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = true; });
    drawer.querySelectorAll('.quick-add-btn[data-variant-id]').forEach(function (btn) {
      var card = btn.closest('.w-32');
      if (!card) return;
      card.style.display = inCart[btn.dataset.variantId] ? 'none' : '';
    });
  }

  var cartLineHandlersAttached = false;
  function attachCartLineHandlers() {
    if (cartLineHandlersAttached) return;
    var container = document.getElementById('cart-drawer-content');
    if (!container) return;
    cartLineHandlersAttached = true;
    container.addEventListener('click', function (e) {
      var target = e.target;
      var lineId = target.dataset.lineId;
      if (!lineId) return;

      if (target.classList.contains('cart-line-minus')) {
        var span = target.nextElementSibling;
        var qty = parseInt(span ? span.textContent : '1', 10);
        if (qty <= 1) {
          removeCartLine(lineId).then(refreshCartDrawer);
        } else {
          updateCartLine(lineId, qty - 1).then(refreshCartDrawer);
        }
      } else if (target.classList.contains('cart-line-plus')) {
        var span2 = target.previousElementSibling;
        var qty2 = parseInt(span2 ? span2.textContent : '1', 10);
        updateCartLine(lineId, qty2 + 1).then(refreshCartDrawer);
      } else if (target.classList.contains('cart-line-remove')) {
        removeCartLine(lineId).then(refreshCartDrawer);
      }
    });
  }

  // Global delegated quick-add (drawer recommendations, cart page, anywhere)
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var target = e.target.closest ? e.target.closest('.quick-add-btn') : null;
      if (!target || target.disabled) return;
      var variantId = target.dataset.variantId;
      if (!variantId) return;
      var origLabel = target.innerHTML;
      target.disabled = true;
      target.innerHTML = SPINNER_SVG + 'Adding…';
      addToCart(parseInt(variantId, 10), 1).then(function () {
        target.innerHTML = CHECK_SVG + 'Added';
        target.style.transform = 'scale(1.03)';
        fetchCart().then(function (cart) {
          renderCartDrawer(cart);
          openDrawer('cart-drawer');
        });
        setTimeout(function () {
          target.innerHTML = origLabel;
          target.style.transform = '';
          target.disabled = false;
        }, 1600);
      }).catch(function () {
        target.innerHTML = origLabel;
        target.disabled = false;
      });
    });
  }

  function refreshCartDrawer() {
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
    });
  }

  /* =========================================================
   * 8. ADD TO CART BUTTON ANIMATION
   * ========================================================= */
  var SPINNER_SVG = '<svg class="animate-spin inline-block mr-1" width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="2" stroke-opacity="0.25"/><path d="M14.5 8A6.5 6.5 0 0 0 8 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var CHECK_SVG = '<svg class="inline-block mr-1" width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-6" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function animateAddToCartBtn(btn, variantId, qty, originalLabel) {
    if (!btn) return;
    btn.disabled = true;
    btn.innerHTML = SPINNER_SVG + 'Adding…';

    addToCart(variantId, qty)
      .then(function (result) {
        btn.innerHTML = CHECK_SVG + 'Added';
        btn.style.transform = 'scale(1.03)';

        // Fire analytics
        fireAddToCartAnalytics(variantId, qty);

        // Refresh cart
        fetchCart().then(function (cart) {
          renderCartDrawer(cart);
          openDrawer('cart-drawer');
        });

        setTimeout(function () {
          btn.innerHTML = originalLabel;
          btn.style.transform = '';
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.innerHTML = originalLabel;
        btn.style.transform = '';
        btn.disabled = false;
      });
  }

  function initAddToCartButtons() {
    var mainBtn = document.getElementById('add-to-cart-btn');
    var stickyBtn = document.getElementById('sticky-add-to-cart');

    function handleAtcClick(e) {
      var btn = e.currentTarget;
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;
      var qtyEl = document.getElementById('qty-value');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var originalLabel = btn.innerHTML;
      animateAddToCartBtn(btn, parseInt(variantId, 10), qty, originalLabel);
      // Mirror to the other button if present
      var otherId = btn.id === 'add-to-cart-btn' ? 'sticky-add-to-cart' : 'add-to-cart-btn';
      var other = document.getElementById(otherId);
      if (other && !other.disabled) {
        var origOther = other.innerHTML;
        other.disabled = true;
        other.innerHTML = SPINNER_SVG + 'Adding…';
        setTimeout(function () {
          other.innerHTML = CHECK_SVG + 'Added';
          other.style.transform = 'scale(1.03)';
          setTimeout(function () {
            other.innerHTML = origOther;
            other.style.transform = '';
            other.disabled = false;
          }, 1600);
        }, 600); // rough sync with actual request
      }
    }

    if (mainBtn) mainBtn.addEventListener('click', handleAtcClick);
    if (stickyBtn) stickyBtn.addEventListener('click', handleAtcClick);
  }

  /* =========================================================
   * 9. QUANTITY PICKER
   * ========================================================= */
  function initQuantityPicker() {
    var minus = document.getElementById('qty-minus');
    var plus = document.getElementById('qty-plus');
    var display = document.getElementById('qty-display');
    var hidden = document.getElementById('qty-value');
    if (!minus || !plus) return;

    function getQty() { return parseInt(display ? display.textContent : '1', 10) || 1; }
    function setQty(n) {
      if (n < 1) n = 1;
      if (display) display.textContent = n;
      if (hidden) hidden.value = n;
    }

    minus.addEventListener('click', function () { setQty(getQty() - 1); });
    plus.addEventListener('click', function () { setQty(getQty() + 1); });
  }

  /* =========================================================
   * 10. GALLERY
   * ========================================================= */
  function initGallery() {
    var track = document.getElementById('gallery-track');
    var thumbsContainer = document.getElementById('gallery-thumbs');
    if (!track) return;

    var thumbs = document.querySelectorAll('.gallery-thumb');
    var slides = track.children;
    var count = slides.length;
    if (!count) return;

    function scrollToIndex(idx) {
      var width = track.clientWidth;
      track.scrollTo({ left: idx * width, behavior: 'smooth' });
    }

    function setActiveThumb(idx) {
      thumbs.forEach(function (t, i) {
        if (i === idx) {
          t.classList.remove('border-transparent');
          t.classList.add('border-ink');
        } else {
          t.classList.remove('border-ink');
          t.classList.add('border-transparent');
        }
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.thumbIndex, 10) || 0;
        scrollToIndex(idx);
        setActiveThumb(idx);
      });
    });

    // Update active thumb on scroll
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var width = track.clientWidth;
        if (!width) return;
        var idx = Math.round(track.scrollLeft / width);
        setActiveThumb(idx);
      }, 80);
    });

    setActiveThumb(0);
  }

  /* =========================================================
   * 11. VARIANT SELECTOR
   * ========================================================= */
  function initVariantSelector() {
    var jsonEl = document.getElementById('product-variants-json');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    // Build option position map: determine option count from first variant
    var optionCount = variants[0].options ? variants[0].options.length : 0;
    var selectedOptions = {};

    // Try to initialize from URL params
    var urlParams = new URLSearchParams(location.search);
    var hasUrlVariant = false;
    if (urlParams.has('variant')) {
      var urlVariantId = parseInt(urlParams.get('variant'), 10);
      var urlVariant = variants.find(function (v) { return v.id === urlVariantId; });
      if (urlVariant && urlVariant.options) {
        urlVariant.options.forEach(function (val, i) {
          selectedOptions[i + 1] = val;
        });
        hasUrlVariant = true;
      }
    }

    if (!hasUrlVariant) {
      // Default to first available variant
      var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
      if (firstAvail && firstAvail.options) {
        firstAvail.options.forEach(function (val, i) {
          selectedOptions[i + 1] = val;
        });
      }
    }

    function findMatchingVariant() {
      return variants.find(function (v) {
        return v.options && v.options.every(function (val, i) {
          return selectedOptions[i + 1] === val;
        });
      });
    }

    function getOptionValuesAtPosition(pos) {
      var seen = {};
      variants.forEach(function (v) {
        if (v.options && v.options[pos - 1] !== undefined) {
          seen[v.options[pos - 1]] = true;
        }
      });
      return Object.keys(seen);
    }

    function isOptionValueAvailableWith(pos, val) {
      // Check if any variant with current OTHER options selected + this value is available
      return variants.some(function (v) {
        if (!v.available) return false;
        if (!v.options) return false;
        if (v.options[pos - 1] !== val) return false;
        // All other positions must match selected
        return v.options.every(function (o, i) {
          var p = i + 1;
          if (p === pos) return true;
          return !selectedOptions[p] || selectedOptions[p] === o;
        });
      });
    }

    function updateOptionChips() {
      // Chip styles mirror Hydrogen's ProductForm: selected = border-ink,
      // idle = border-ink/20 + hover, unavailable adds opacity-30.
      var chips = document.querySelectorAll('.variant-option');
      chips.forEach(function (chip) {
        var pos = parseInt(chip.dataset.optionPosition, 10);
        var val = chip.dataset.optionValue;
        var isSelected = selectedOptions[pos] === val;
        var isAvail = isOptionValueAvailableWith(pos, val);

        chip.classList.remove('border-ink', 'border-ink/20', 'hover:border-ink/50', 'opacity-30');

        if (isSelected) {
          chip.classList.add('border-ink');
        } else {
          chip.classList.add('border-ink/20', 'hover:border-ink/50');
        }
        if (!isAvail) chip.classList.add('opacity-30');
      });
    }

    function renderPrice(variant) {
      var priceEl = document.getElementById('product-price');
      if (!priceEl) return;
      var price = variant.price;
      var compare = variant.compare_at_price;
      // Mirrors the ProductPrice markup (snippets/price.liquid / Hydrogen ProductPrice.tsx)
      if (compare && compare > price) {
        priceEl.innerHTML = '<div aria-label="Price" class="product-price" role="group"><div class="product-price-on-sale">' + formatMoney(price) + '<s>' + formatMoney(compare) + '</s></div></div>';
      } else {
        priceEl.innerHTML = '<div aria-label="Price" class="product-price" role="group">' + formatMoney(price) + '</div>';
      }
    }

    function applyVariantUpdate(variant) {
      if (!variant) return;

      // Price
      renderPrice(variant);

      // Installments
      var installEl = document.getElementById('installments-amount');
      if (installEl) installEl.textContent = formatMoney(Math.round(variant.price / 4));

      // Availability chip — rebuilt with the full markup (pulsing dot + label),
      // mirroring the Liquid/Hydrogen chip exactly.
      var chipEl = document.getElementById('availability-chip');
      if (chipEl) {
        var avail = variant.available;
        chipEl.className = 'inline-flex items-center gap-2 border rounded-full font-sans text-[10px] uppercase tracking-[0.1em] px-4 py-1.5 ' + (avail ? 'text-[#00a233] border-[#00a233]' : 'text-clay border-clay');
        chipEl.innerHTML = '<span class="relative flex h-1.5 w-1.5">' +
          (avail ? '<span class="absolute inline-flex h-full w-full rounded-full bg-[#00a233] opacity-60 animate-ping"></span>' : '') +
          '<span class="relative inline-flex h-1.5 w-1.5 rounded-full ' + (avail ? 'bg-[#00a233]' : 'bg-clay') + '"></span>' +
          '</span>' +
          (avail ? 'In Stock' : 'Sold Out');
      }

      // ATC buttons
      ['add-to-cart-btn', 'sticky-add-to-cart'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (!btn) return;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        if (!variant.available) {
          btn.textContent = 'Sold Out';
        } else {
          btn.textContent = id === 'sticky-add-to-cart' ? 'Add to Bag' : 'Add to Bag';
        }
      });

      // Sticky price
      var stickyPrice = document.getElementById('sticky-price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      // URL
      var url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      // Gallery image
      if (variant.featured_image) {
        var track = document.getElementById('gallery-track');
        if (track) {
          var imgs = track.querySelectorAll('img');
          var targetSrc = variant.featured_image.src;
          var found = -1;
          imgs.forEach(function (img, i) {
            if (img.src.includes(targetSrc.split('?')[0].split('/').pop().replace(/(_\d+x\d*\.\w+)$/, ''))) {
              found = i;
            }
          });
          if (found >= 0) {
            var width = track.clientWidth;
            track.scrollTo({ left: found * width, behavior: 'smooth' });
          }
        }
      }
    }

    // Init display
    var currentVariant = findMatchingVariant();
    updateOptionChips();
    if (currentVariant) applyVariantUpdate(currentVariant);

    // Click handlers
    document.querySelectorAll('.variant-option').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pos = parseInt(chip.dataset.optionPosition, 10);
        var val = chip.dataset.optionValue;
        selectedOptions[pos] = val;
        updateOptionChips();
        var matched = findMatchingVariant();
        if (matched) applyVariantUpdate(matched);
      });
    });
  }

  /* =========================================================
   * 12. STICKY BUY BAR
   * ========================================================= */
  function initStickyBuyBar() {
    var buyArea = document.getElementById('buy-area');
    var stickyBar = document.getElementById('sticky-buy-bar');
    if (!buyArea || !stickyBar) return;

    // Visible only after the real Add to Bag area scrolls out ABOVE the viewport
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (show) {
          stickyBar.classList.remove('translate-y-full');
          stickyBar.classList.add('translate-y-0');
        } else {
          stickyBar.classList.add('translate-y-full');
          stickyBar.classList.remove('translate-y-0');
        }
      });
    }, { threshold: 0 });

    observer.observe(buyArea);
  }

  /* =========================================================
   * 13. REVEAL OBSERVER
   * ========================================================= */
  function initRevealObserver() {
    var elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return;

    elements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(2rem)';
      el.style.transition = 'opacity 700ms ease, transform 700ms ease';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* =========================================================
   * 14. PRODUCT FAQ TABS
   * ========================================================= */
  function initFaqTabs() {
    var tabs = document.querySelectorAll('[data-faq-tab]');
    var panels = document.querySelectorAll('[data-faq-panel]');
    if (!tabs.length) return;

    function activateTab(tabKey) {
      tabs.forEach(function (t) {
        var isActive = t.dataset.faqTab === tabKey;
        t.classList.toggle('bg-ink', isActive);
        t.classList.toggle('text-paper', isActive);
        t.classList.toggle('border-ink', isActive);
        t.classList.toggle('bg-paper', !isActive);
        t.classList.toggle('text-ink', !isActive);
        t.classList.toggle('border-ink/15', !isActive);
        t.classList.toggle('hover:border-ink/50', !isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.dataset.faqPanel !== tabKey;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.dataset.faqTab);
      });
    });
  }

  /* =========================================================
   * 15. SEARCH (PREDICTIVE)
   * ========================================================= */
  function initSearch() {
    var input = document.getElementById('search-input');
    var results = document.getElementById('search-results');
    if (!input || !results) return;

    var debounceTimer;

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = '<p class="font-sans text-xs text-ink/50 py-4 text-center">No results found</p>';
              return;
            }
            var html = '<ul>';
            items.forEach(function (item) {
              var imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
              // suggest.json returns prices as decimal STRINGS in dollars (e.g. "69.00")
              var compareRaw = parseFloat(item.compare_at_price_max || item.compare_at_price || 0);
              var priceRaw = parseFloat(item.price || 0);
              var price = priceRaw ? '<span class="font-semibold text-ink">$' + priceRaw.toFixed(2) + '</span>' : '';
              if (priceRaw && compareRaw > priceRaw) {
                price += ' <s class="text-ink/40">$' + compareRaw.toFixed(2) + '</s>';
              }
              html += [
                '<li>',
                  '<a href="' + item.url + '" class="flex items-center gap-3 py-2.5 border-b border-ink/10 last:border-0 hover:opacity-70 transition-opacity">',
                    imgUrl ? '<img src="' + imgUrl + '" class="w-12 h-12 object-cover rounded-lg" loading="lazy" />' : '<div class="w-12 h-12 bg-ink/10 rounded-lg"></div>',
                    '<div>',
                      '<p class="font-sans text-xs font-medium text-ink">' + escHtml(item.title) + '</p>',
                      price ? '<p class="font-sans text-[11px] text-ink/50">' + price + '</p>' : '',
                    '</div>',
                  '</a>',
                '</li>'
              ].join('');
            });
            html += '</ul>';
            results.innerHTML = html;
          })
          .catch(function () {
            results.innerHTML = '';
          });
      }, 300);
    });
  }

  /* =========================================================
   * 16. NEWSLETTER
   * ========================================================= */
  function initNewsletter() {
    // Newsletter submits natively via Shopify's {% form 'customer' %} —
    // the platform handles the CAPTCHA challenge and success state.
    // No JS interception (a fetch() POST gets rejected with 400 Missing
    // CAPTCHA token and would fake a success message).
  }

  /* =========================================================
   * 17. REVIEWS SECTION
   * ========================================================= */
  function initReviews() {
    // Reviews are rendered server-side by product-reviews.liquid.
    // JS handles: show-more, lightbox, read-more expand, smooth scroll.

    // Show more reviews
    var showMoreBtn = document.getElementById('show-more-reviews');
    var grid = document.getElementById('reviews-grid');
    var remaining = document.getElementById('reviews-remaining');
    if (showMoreBtn && grid && remaining) {
      showMoreBtn.addEventListener('click', function () {
        // +6 per click, matching Hydrogen's PAGE_SIZE
        var cards = remaining.querySelectorAll('.review-card');
        var take = Math.min(6, cards.length);
        for (var i = 0; i < take; i++) grid.appendChild(cards[i]);
        if (remaining.querySelectorAll('.review-card').length === 0) {
          showMoreBtn.parentElement.style.display = 'none';
        }
      });
    }

    // Lightbox for review photos
    var lightbox = document.getElementById('review-lightbox');
    var lightboxImg = document.getElementById('lightbox-img');
    var lightboxClose = document.getElementById('lightbox-close');
    if (lightbox && lightboxImg) {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.review-photo-btn');
        if (btn) {
          lightboxImg.src = btn.dataset.photoUrl || '';
          lightboxImg.alt = btn.dataset.photoAlt || '';
          lightbox.classList.remove('hidden');
        }
      });
      function closeLightbox() { lightbox.classList.add('hidden'); }
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) closeLightbox();
      });
    }

    // "Read more" expand for long review bodies
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('review-expand')) {
        var body = e.target.previousElementSibling;
        if (body && body.classList.contains('review-body')) {
          body.classList.remove('line-clamp-5');
          e.target.style.display = 'none';
        }
      }
    });

    // Smooth scroll to reviews from rating link
    document.querySelectorAll('.js-scroll-to-reviews').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* =========================================================
   * 18. PROGRESS BAR (NAV)
   * ========================================================= */
  function initNavProgress() {
    var bar = document.getElementById('nav-progress');
    if (!bar) return;
    // Show on navigation start (page:loading) — Shopify theme events
    document.addEventListener('page:loading', function () {
      bar.style.opacity = '1';
      bar.style.width = '0%';
      setTimeout(function () { bar.style.width = '80%'; }, 50);
    });
    document.addEventListener('page:loaded', function () {
      bar.style.width = '100%';
      setTimeout(function () { bar.style.opacity = '0'; bar.style.width = '0%'; }, 300);
    });
  }

  /* =========================================================
   * 19. ANALYTICS
   * ========================================================= */
  function safeGtag() {
    if (typeof gtag === 'function') {
      gtag.apply(null, arguments);
    }
  }

  function safeFbq() {
    if (typeof fbq === 'function') {
      fbq.apply(null, arguments);
    }
  }

  function getNumericId(gid) {
    if (!gid) return null;
    var parts = String(gid).split('/');
    return parts[parts.length - 1];
  }

  function buildFeedItemId(productId, variantId) {
    return 'shopify_US_' + productId + '_' + variantId;
  }

  function fireProductViewAnalytics() {
    var jsonEl = document.getElementById('product-variants-json');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    // Get current variant from URL or first available
    var urlParams = new URLSearchParams(location.search);
    var selectedVariant = null;
    if (urlParams.has('variant')) {
      var vid = parseInt(urlParams.get('variant'), 10);
      selectedVariant = variants.find(function (v) { return v.id === vid; });
    }
    if (!selectedVariant) selectedVariant = variants.find(function (v) { return v.available; }) || variants[0];

    if (!selectedVariant) return;

    // Get product ID — try ShopifyAnalytics meta or parse from page
    var productId = null;
    var metaJsonEl = document.getElementById('product-meta-json');
    if (metaJsonEl) {
      try {
        var meta = JSON.parse(metaJsonEl.textContent);
        productId = getNumericId(meta.productId || meta.id);
      } catch (e) {}
    }
    if (!productId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      productId = String(window.ShopifyAnalytics.meta.product.id);
    }
    if (!productId) return; // can't build feedItemId without productId

    var variantId = String(selectedVariant.id);
    var feedItemId = buildFeedItemId(productId, variantId);
    var priceCents = selectedVariant.price;
    var priceValue = priceCents / 100;

    safeGtag('event', 'view_item', {
      currency: 'USD',
      value: priceValue,
      items: [{
        id: feedItemId,
        google_business_vertical: 'retail'
      }]
    });

    safeFbq('track', 'ViewContent', {
      content_ids: [feedItemId],
      content_type: 'product',
      value: priceValue,
      currency: 'USD'
    });
  }

  function fireAddToCartAnalytics(variantId, qty) {
    var jsonEl = document.getElementById('product-variants-json');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variant = variants && variants.find(function (v) { return v.id === variantId; });
    if (!variant) return;

    var productId = null;
    var metaJsonEl = document.getElementById('product-meta-json');
    if (metaJsonEl) {
      try {
        var meta = JSON.parse(metaJsonEl.textContent);
        productId = getNumericId(meta.productId || meta.id);
      } catch (e) {}
    }
    if (!productId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      productId = String(window.ShopifyAnalytics.meta.product.id);
    }
    if (!productId) return;

    var feedItemId = buildFeedItemId(productId, String(variantId));
    var priceValue = (variant.price * qty) / 100;

    safeGtag('event', 'add_to_cart', {
      currency: 'USD',
      value: priceValue,
      items: [{
        id: feedItemId,
        google_business_vertical: 'retail',
        quantity: qty
      }]
    });

    safeFbq('track', 'AddToCart', {
      content_ids: [feedItemId],
      content_type: 'product',
      value: priceValue,
      currency: 'USD'
    });
  }

  function initAnalytics() {
    captureClickParams();
    safeGtag('event', 'page_view', { page_location: location.href });
    safeFbq('track', 'PageView');
    fireProductViewAnalytics();
  }

  /* =========================================================
   * 20. CHECKOUT BUTTON DECORATION
   * ========================================================= */
  function initCheckoutDecoration() {
    var checkoutBtn = document.getElementById('checkout-btn');
    if (checkoutBtn && checkoutBtn.href) {
      checkoutBtn.href = decorateCheckoutUrl(checkoutBtn.href);
      // Redirect feedback, mirroring Hydrogen's CheckoutButton
      checkoutBtn.addEventListener('click', function () {
        checkoutBtn.setAttribute('aria-busy', 'true');
        checkoutBtn.classList.add('opacity-80', 'pointer-events-none');
        checkoutBtn.classList.remove('hover:bg-clay');
        checkoutBtn.innerHTML = SPINNER_SVG + ' Taking you to secure checkout…';
      });
    }
  }

  /* =========================================================
   * 21. UTILITY: HTML ESCAPE
   * ========================================================= */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* =========================================================
   * 22. CART PAGE INIT
   * ========================================================= */
  function initCartPage() {
    initCheckoutDecoration();

    var cartPage = document.getElementById('cart-page');
    if (!cartPage) return;

    // Cart qty buttons and remove buttons use data-key and data-action / class
    cartPage.addEventListener('click', function (e) {
      var target = e.target;
      var key = target.dataset.key;

      if (target.classList.contains('cart-qty-btn') && key) {
        var action = target.dataset.action;
        var display = target.parentElement.querySelector('.cart-qty-display');
        var qty = parseInt(display ? display.textContent : '1', 10) || 1;
        var newQty = action === 'minus' ? Math.max(0, qty - 1) : qty + 1;
        updateCartLine(key, newQty).then(function () { location.reload(); });
        return;
      }

      if (target.classList.contains('cart-remove-btn') && key) {
        removeCartLine(key).then(function () { location.reload(); });
        return;
      }
      // (quick-add is handled globally by initQuickAdd)
    });
  }

  /* =========================================================
   * 22b. COLLECTION LOAD MORE (mirrors Hydrogen's Pagination)
   * ========================================================= */
  function initLoadMore() {
    var grid = document.getElementById('collection-grid');
    if (!grid) return;

    function wire(btnId, prepend) {
      var btn = document.getElementById(btnId);
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('href');
        btn.innerHTML = '<span class="inline-flex items-center gap-2">' + SPINNER_SVG + 'Loading…</span>';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('collection-grid');
            if (newGrid) {
              var children = Array.prototype.slice.call(newGrid.children);
              if (prepend) {
                children.reverse().forEach(function (child) { grid.insertBefore(child, grid.firstChild); });
              } else {
                children.forEach(function (child) { grid.appendChild(child); });
              }
            }
            var newBtn = doc.getElementById(btnId);
            if (newBtn) {
              btn.setAttribute('href', newBtn.getAttribute('href'));
              btn.innerHTML = prepend ? '<span>↑ Load previous</span>' : '<span>Load more ↓</span>';
            } else {
              btn.parentElement.remove();
            }
          })
          .catch(function () { location.href = url; });
      });
    }

    wire('load-more-btn', false);
    wire('load-prev-btn', true);
  }

  /* =========================================================
   * 22c. COLLECTION SORT SELECT
   * ========================================================= */
  function initSortSelect() {
    var select = document.getElementById('sort-select');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(location.href);
      if (select.value === select.dataset.defaultSort) {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', select.value);
      }
      url.searchParams.delete('page');
      location.href = url.toString();
    });
  }

  /* =========================================================
   * 22d. COLLECTION TABS (home section)
   * ========================================================= */
  function initCollectionTabs() {
    var tabs = document.querySelectorAll('.collection-tab');
    var panels = document.querySelectorAll('.collection-panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.ctab;
        tabs.forEach(function (t) {
          var isActive = t.dataset.ctab === key;
          t.classList.toggle('bg-ink', isActive);
          t.classList.toggle('text-paper', isActive);
          t.classList.toggle('border-ink', isActive);
          t.classList.toggle('bg-paper', !isActive);
          t.classList.toggle('text-ink', !isActive);
          t.classList.toggle('border-ink/15', !isActive);
          t.classList.toggle('hover:border-ink/50', !isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.dataset.cpanel !== key;
        });
      });
    });
  }

  /* =========================================================
   * 22e. COLLECTION SHOWCASE CAROUSELS (arrow navigation)
   * ========================================================= */
  function initShowcaseCarousels() {
    function updateArrows(track) {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      document.querySelectorAll('.showcase-prev[data-target="' + track.id + '"]').forEach(function (b) { b.disabled = atStart; });
      document.querySelectorAll('.showcase-next[data-target="' + track.id + '"]').forEach(function (b) { b.disabled = atEnd; });
    }

    document.querySelectorAll('.showcase-track').forEach(function (track) {
      updateArrows(track);
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { updateArrows(track); });
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.showcase-prev, .showcase-next') : null;
      if (!btn) return;
      var track = document.getElementById(btn.dataset.target);
      if (!track) return;
      var dir = btn.classList.contains('showcase-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    });
  }

  /* =========================================================
   * 23. BOOT — DOMContentLoaded
   * ========================================================= */
  function boot() {
    initAnnouncementBar();
    initDrawers();
    initNavProgress();
    initGallery();
    initQuantityPicker();
    initVariantSelector();
    initAddToCartButtons();
    initStickyBuyBar();
    initRevealObserver();
    initFaqTabs();
    initSearch();
    initNewsletter();
    initReviews();
    initCartPage();
    initLoadMore();
    initSortSelect();
    initCollectionTabs();
    initShowcaseCarousels();
    initQuickAdd();
    attachCartLineHandlers();
    initAnalytics();

    // Fetch cart count on load
    fetchCart().then(function (cart) {
      updateCartBadge(cart.item_count);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
